import React, { useState } from 'react';
import { MdOutlineDelete } from "react-icons/md";

const SACCodeSelect = ({
    classifications,
    SearchData,
    setShowDeletePopup,
    setItemToDelete,
    selectedHSNData,
    onClose
}) => {
    const [selectedItem, setSelectedItem] = useState({ type: null, id: null });
    
    const handleSelect = (id, code) => {
        setSelectedItem({ type: 'classification', id, code });
        selectedHSNData({ type: 'classification', id, code });      
        onClose();
    };

    const isSelected = (id) => selectedItem.type === 'classification' && selectedItem.id === id;

    const filteredClassifications = SearchData
        ? classifications.filter(c => c.classification_code?.toString().includes(SearchData.toString()))
        : classifications;

    return (
        <div className='h-80 overflow-auto border-2 p-2 rounded-lg'>
        <table className="w-full relative font-normal">
            <tbody>
                {filteredClassifications.map((classificationItem) => (
                    <tr key={classificationItem.id} className="border-b border-gray-400">
                        <td className="py-3 pl-4 cursor-pointer flex items-center gap-2">
                            <MdOutlineDelete
                                onClick={() => {
                                    setShowDeletePopup(true);
                                    setItemToDelete({ id: classificationItem.id, code: classificationItem.classification_code, type: 'classification' });
                                }}
                                className="text-gray-600 text-2xl cursor-pointer"
                            />
                            <input
                                type="checkbox"
                                className="scale-150 cursor-pointer"
                                onChange={() => handleSelect(classificationItem.id, classificationItem.classification_code)}
                                checked={isSelected(classificationItem.id)}
                            />
                            {classificationItem.classification_code}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
        </div>
    );
};

export default SACCodeSelect;
